module.exports = __webpack_public_path__ + "img/checkout.e397ab95.png";